import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

import {
  Table,
  Layout,
  Space,
  Row,
  Col,
  Button,
  // FloatButton,
} from "antd";
import dayjs from "dayjs";
// import {
//   // PlusCircleOutlined,
//   EditOutlined,
//   // DeleteOutlined,
//   EyeFilled,
// } from "@ant-design/icons";

import { usePaginate } from "backend/usePaginate";
// import { useBackend } from "backend/useBackend";
import SearchBy from "components/SearchBy";
import PageLimitDropDown from "components/PageLimitDropDown";
// import { DeleteConfirm } from "cms/components/DeleteConfirm";
import TagStatus from "cms/components/TagStatus.js";

var localizedFormat = require("dayjs/plugin/localizedFormat");

dayjs.extend(localizedFormat);
const { Content } = Layout;

const endpoint = "users";

const Users = () => {
  const tableRef = useRef();
  // const navigate = useNavigate();
  // const { pathname } = useLocation();
  const [list, setList] = useState([]);
  // const { deleteItem } = useBackend();
  const [showMore, setShowMore] = useState(true);

  const {
    loading,
    loadingMore,
    hasMore,
    items,
    loadMore,
    // deleteById
  } = usePaginate(endpoint);

  useEffect(() => {
    setList(items);
  }, [items]);

  // console.log(list)

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list);
      setShowMore(false);
    } else {
      setList(items);
      setShowMore(true);
    }
  };

  const columnsSearchable = [
    {
      key: "firstName",
      title: "First Name",
      searchable: true, // this is used for searchBy component
    },
    {
      key: "lastName",
      title: "Last Name",
      searchable: true, // this is used for searchBy component
    },
    {
      key: "email",
      title: "Email",
      searchable: true, // this is used for searchBy component
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.firstName.length - b.firstName.length,
      sortDirections: ["ascend", "descend"],
      render: (firstName, row) => (
        <span>
          {firstName} {row?.lastName}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      responsive: ["md"],
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      responsive: ["md"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      responsive: ["md"],
      render: (status) => <TagStatus status={status} />,
    },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => dayjs(createdAt).format("L LT"),
    },
    {
      title: "Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      // render: (updatedAt, row) => updatedAt.toString()
      render: (updatedAt) => dayjs(updatedAt).format("L LT"),
    },
    // {
    //   title: "Actions",
    //   className: "table-actions",
    //   dataIndex: "id",
    //   key: "id",
    //   render: (id, row) => (
    //     <Space size="middle">
    //       <EyeFilled
    //         onClick={() => navigate(`${pathname}/view/${id}`, { state: row })}
    //       />
    //       <EditOutlined
    //         onClick={() => navigate(`${pathname}/edit/${id}`, { state: row })}
    //       />
    //       <DeleteConfirm
    //         onConfirm={() =>
    //           deleteItem(endpoint, row.id, {
    //             redirectTo: endpoint,
    //             msg: {
    //               loading: "Deleting...",
    //               success: "Deleted successfully.",
    //             },
    //             loading: true,
    //           }).then(() => deleteById(row.id))
    //         }
    //       />
    //     </Space>
    //   ),
    // },
  ];

  const onChange = (data) => {
    console.log(data);
  };

  return (
    <Content>
      {/* <FloatButton
        icon={<PlusCircleOutlined />}
        type="primary"
        tooltip="Add New"
        onClick={() => navigate(`${pathname}/add`)}
      /> */}
      <Row justify="space-between" style={{ marginBottom: "1em" }}>
        <Col xs={18} lg={12}>
          <Space>
            <SearchBy
              endpoint={endpoint}
              columns={columnsSearchable}
              setResult={setResult}
            />
          </Space>
        </Col>
        {/* <Col xs={6} lg={12} className="text-right"> */}
        {/* <Link to={`${pathname}/add`}>
            <Button type="primary">Add Item</Button>
          </Link> */}
        {/* </Col> */}
      </Row>
      <Table
        rowKey="id"
        dataSource={list}
        columns={columns}
        loading={loading}
        onChange={onChange}
        pagination={false}
        ref={tableRef}
      />
      <Row justify="space-between" style={{ marginTop: "1.5em" }}>
        <Col>
          <PageLimitDropDown />
        </Col>
        <Col>
          {showMore && hasMore && (
            <Button type="primary" onClick={loadMore} loading={loadingMore}>
              {loadingMore ? "Loading..." : "Load More"}
            </Button>
          )}
        </Col>
      </Row>
    </Content>
  );
};

export default Users;
